<h3 *ngIf="!interactions.tickets.length" translate="crm/user-profile/interactions/nothing-to-display"></h3>
<ng-container *ngFor="let ticket of interactions.tickets">
  <div [ngSwitch]="ticket.via.channel" class="crm-interaction">
    <div>
      <strong>Via: </strong>
      <span *ngSwitchCase="'email'" translate="email"></span>
      <span *ngSwitchCase="'call'" translate="crm/user-profile/interactions/phone-call"></span>
      <span *ngSwitchDefault>{{ ticket.via.channel }}</span>
    </div>
    <div>
      <strong translate="crm/user-profile/interactions/created_at"></strong>
      <span>{{ ticket.created_at | dateTimezone: 'medium' }}</span>
    </div>
    <div>
      <strong translate="crm/user-profile/interactions/subject"></strong>
      <span>{{ ticket.subject }}</span>
    </div>
    <div>
      <strong translate="crm/user-profile/interactions/description"></strong>
      <pre>{{ ticket.description }}</pre>
    </div>
    <a href="{{ org.instance_url }}/agent/tickets/{{ ticket.id }}" target="_blank">
      {{ ticket.id }}
      <mat-icon>launch</mat-icon>
    </a>
  </div>
</ng-container>
